export default "__VITE_ASSET__c0OonFKB__"